import { ColumnDef } from "@tanstack/react-table";
import i18n from "@/i18n";

export function getAuditColumns<T>(
  underlyings_columns: ColumnDef<T>[],
): ColumnDef<
  T & {
    audit_action: string;
    audit_timestamp: string;
    audit_user_email: string;
  }
>[] {
  return [
    ...(underlyings_columns.filter(
      (column) => !(column.id && column.id.startsWith("actions")),
    ) as ColumnDef<
      T & {
        audit_action: string;
        audit_timestamp: string;
        audit_user_email: string;
      }
    >[]),
    {
      accessorKey: "audit_action",
      header: () => i18n.t("audit.action", { defaultValue: "Action" }),
    },
    {
      accessorKey: "audit_timestamp",
      header: () => i18n.t("audit.timestamp", { defaultValue: "Timestamp" }),
      cell: ({ row }) => {
        const date = new Date(row.getValue("audit_timestamp"));
        const locale = i18n.language?.startsWith("en") ? "en" : "fr";
        const formatted = date.toLocaleString(locale, {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return <span className="block">{formatted}</span>;
      },
    },
    {
      accessorKey: "audit_user_email",
      header: () => i18n.t("audit.user", { defaultValue: "User" }),
    },
  ];
}
